module.exports = __webpack_public_path__ + "static/img/100085.15bc1372.png";